import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../../Button';
import { Modal } from '../../common/Modal';
import { useApplicationReview } from '../../../contexts/ApplicationReviewContext';
import { validationOfficers } from '../../../data/applicationReview';
import { can } from '../../../utils/applicationQueue';
import type { OwnerApplication } from '../../../types/owner';
export function AssignOfficerModal({
  app,
  onClose
}: {
  app: OwnerApplication | null;
  onClose: () => void;
}) {
  const {
    getReview,
    assignOfficer,
    role
  } = useApplicationReview();
  const current = app ? getReview(app).assignedOfficer : undefined;
  const [officer, setOfficer] = useState(validationOfficers[0]);
  useEffect(() => {
    if (app) setOfficer(current ?? validationOfficers[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [app?.id]);
  const allowed = can(role, 'assign');
  const save = () => {
    if (!app) return;
    assignOfficer(app, officer);
    toast.success(`দায়িত্বপ্রাপ্ত কর্মকর্তা: ${officer}`);
    onClose();
  };
  return <Modal open={Boolean(app)} onClose={onClose} title="কর্মকর্তা নির্ধারণ" footer={<>
          <Button variant="outline" onClick={onClose} data-id="element-266" data-mp="1mi6mzw358icw">বাতিল</Button>
          <Button onClick={save} disabled={!allowed} data-id="element-267" data-mp="1hiby1y2xi2uh">নির্ধারণ করুন</Button>
        </>} data-id="element-265" data-mp="17kec5h8jki51">
      {app && <fieldset className="space-y-2" data-id="element-268" data-mp="1vh1wpi5ecaky">
          <legend className="mb-2 text-sm text-slate-600" data-id="element-269" data-mp="1vg0m1esalq3r">{app.id} • বর্তমান: {current ?? 'নির্ধারিত হয়নি'}</legend>
          {!allowed && <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700" data-id="element-270" data-mp="257n1jnbnybcb">আপনার বর্তমান ভূমিকায় কর্মকর্তা নির্ধারণের অনুমতি নেই।</p>}
          {validationOfficers.map(o => <label key={o} className={`flex cursor-pointer items-center gap-2.5 rounded-md border px-3 py-2.5 text-sm ${officer === o ? 'border-navy-600 bg-navy-50' : 'border-slate-200'}`} data-id="element-271" data-mp="20amupa6zp4k5">
              <input type="radio" name="officer" checked={officer === o} onChange={() => setOfficer(o)} className="accent-navy-800" data-id="element-272" data-mp="2a4my97mmi1qr" />
              <span className="font-medium text-navy-900" data-id="element-273" data-mp="2m8r7excuykc8">{o}</span>
              <span className="ml-auto text-xs text-slate-500" data-id="element-274" data-mp="2m6wofol5d2as">যাচাই কর্মকর্তা</span>
            </label>)}
        </fieldset>}
    </Modal>;
}